import styled from "@emotion/styled";
import { Button, ButtonGroup } from "@mui/material";

export const FloatingBarContainer = styled.div(({ theme }) => ({
	position: "fixed",
	left: 0,
	right: 0,
	bottom: 0,
	width: "100%",
	boxSizing: "border-box",

	backgroundColor: theme.project.colors.backgroundColors.main,
	borderTop: theme.project.borders.presets.outline,

	padding: "16px",

	zIndex: 5,
	display: "flex"
}));

export const FloatingButtonRow = styled.div(({ theme }) => ({
	display: "flex",
	justifyContent: "space-between",
	alignItems: "center",
	gap: "16px",
	width: "100%",
	[theme.breakpoints.down("md")]: {
		flexDirection: "column",
		alignItems: "stretch",
		margin: "16px 0 0 0"
	}
}));

export const SaveLoadButtonGroup = styled.div(({ theme }) => ({
	display: "flex",
	justifyContent: "center",
	flex: 1,
	[theme.breakpoints.down("md")]: {
		width: "100%",
		"& .MuiButtonGroup-root": {
			width: "100%",
			display: "flex"
		},
		"& .MuiButtonGroup-grouped": {
			flex: 1
		}
	}
}));

export const FloatingButtonGroup = styled(ButtonGroup)(({ theme }) => ({
	gap: "16px",
	[theme.breakpoints.down("md")]: {
		width: "100%",
		flexDirection: "column",
		gap: 0,
		"& .MuiButtonGroup-grouped": {
			borderRadius: "4px !important",
			width: "100%"
		}
	}
}));

export const EmptyCartButton = styled(Button)(({ theme }) => ({
	color: theme.project.colors.semanticColors.error,
	textTransform: "uppercase",
	borderColor: theme.project.colors.semanticColors.error,
	display: "flex",
	alignItems: "center",
	whiteSpace: "nowrap",
	[theme.breakpoints.down("md")]: {
		width: "100%"
	}
}));
